import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import themeColors from '../../assets/styles/themeColors';

const CheckboxButton = styled.button`
  appearance: none;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  border-radius: 4px;
  border: ${({ thickBorder }) => (thickBorder ? '2px' : '1px')} solid
    ${({ checked, thickBorder }) => {
      if (checked) return themeColors.colorPrimary;
      return thickBorder
        ? themeColors.colorTextSecondary
        : themeColors.colorCheckboxBorder;
    }};
  background-color: ${({ checked, lightBackground }) => {
    if (checked) return themeColors.colorPrimary;
    return lightBackground ? themeColors.colorIconBackground : 'transparent';
  }};
  cursor: pointer;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    display: ${({ checked }) => (checked ? 'block' : 'none')};
    left: ${({ raisedCheckmark }) => (raisedCheckmark ? '7px' : '6px')};
    top: ${({ raisedCheckmark }) => (raisedCheckmark ? '3px' : '2px')};
    width: 5px;
    height: 10px;
    border: solid #ffffff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;

const CheckboxGTT = ({
  checked,
  onClick,
  name,
  ariaLabel,
  thickBorder,
  raisedCheckmark,
  lightBackground,
}) => (
  <CheckboxButton
    type="button"
    role="checkbox"
    aria-checked={checked}
    aria-label={ariaLabel}
    checked={checked}
    onClick={onClick}
    name={name}
    thickBorder={thickBorder}
    raisedCheckmark={raisedCheckmark}
    lightBackground={lightBackground}
  />
);

CheckboxGTT.propTypes = {
  checked: PropTypes.bool,
  onClick: PropTypes.func,
  name: PropTypes.string,
  ariaLabel: PropTypes.string,
  thickBorder: PropTypes.bool,
  // TargetPriceOrderReview's terms checkbox needs the checkmark nudged
  // 1px right/down (7px/3px) versus the Weight selection drawer's 6px/2px.
  raisedCheckmark: PropTypes.bool,
  // TargetPriceOrderReview's terms checkbox needs a light grey unchecked
  // background instead of the default transparent.
  lightBackground: PropTypes.bool,
};

export default CheckboxGTT;
